

import React from 'react'
import { motion } from "framer-motion";


const DealStatCard = (
   {color,
   subtitle,
   title,
   icon,
   count,
   trend,
   change,
   itemVariants}
) => {
  return (
     <motion.div
               
                variants={itemVariants}
                className={`group relative bg-white rounded-2xl overflow-hidden`}
              >
                {/* Gradient Background */}
                <div
                  className={`absolute inset-0 bg-gradient-to-br from-${color}-50 to-white opacity-50`}
                ></div>

                {/* Glass Effect Top Bar */}
                <div
                  className={`absolute top-0 left-0 right-0 h-1 bg-${color}-500`}
                ></div>

                <div className="relative p-6">
                  {/* Header Section */}
                  <div className="flex justify-between items-start mb-6">
                    <div>
                      <div
                        className={`inline-flex items-center px-2.5 py-1 rounded-lg 
                        bg-${color}-50 text-${color}-700 text-xs font-medium tracking-wide`}
                      >
                        {subtitle}
                      </div>
                      <h3 className="mt-2 text-xl font-bold text-gray-900">
                        {title}
                      </h3>
                    </div>
                    <div
                      className={`flex items-center justify-center w-12 h-12 rounded-xl
                      bg-${color}-50 text-${color}-600 
                      group-hover:bg-${color}-100 transition-colors duration-300`}
                    >
                      {icon}
                    </div>
                  </div>

                  {/* Stats Section */}
                  <div className="flex items-baseline gap-2">
                    <h2 className="text-4xl font-bold text-gray-900">
                      {count}
                    </h2>
                    <div
                      className={`flex items-center px-2 py-0.5 rounded-full text-sm
                      ${
                        trend === "up"
                          ? "text-emerald-700 bg-emerald-50"
                          : "text-rose-700 bg-rose-50"
                      }`}
                    >
                      <span className="mr-1">
                        {trend === "up" ? "↑" : "↓"}
                      </span>
                      {Math.abs(change)}%
                    </div>
                  </div>
                </div>
              </motion.div>
  )
}

export default DealStatCard
